// import './register.css';
import '../Footer/Footer'
import React, { useState, useEffect } from "react";
import { emailVerify, otpVerify, userforgotpassword, userlogin, userregistration, userResetpassword } from "../../../services/CommonService";
import { Link, useLocation } from "react-router-dom";
import { Modal, Button, Form, Row, Col, Container } from 'react-bootstrap';
import Swal from 'sweetalert2';
import Registration from '../Register/register';

function UserLogin({ show, onHide, onShowRegister }) {

    const [termsAccepted, setTermsAccepted] = useState(false);
    // const [showModal, setShowModal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showAddForm, setShowAddForm] = useState(false);
    const [validated, setValidated] = useState(false);
    const [otpTimerKey, setOtpTimerKey] = useState(0);
    const [emailSent, setEmailSent] = useState(false);
    const [passwordMatchError, setPasswordMatchError] = useState(false);
    const [error, setError] = useState('');
    const [otpTimer, setOtpTimer] = useState(120); // 2 minutes = 120 seconds
    const [showResendButton, setShowResendButton] = useState(false);
    const [showVerifyEmailModal, setShowVerifyEmailModal] = useState(false);
    const [forgotEmail, setForgotEmail] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [showRegistrationModal, setShowRegistrationModal] = useState(false);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
    const [captcha, setCaptcha] = useState(generateCaptcha());
    const [captchaInput, setCaptchaInput] = useState('');
    const [captchaError, setCaptchaError] = useState('');
    const [resetFormotp, setResetForm] = useState({
        otp: '',
        newPassword: '',
        confirmPassword: ''
    });

    function generateCaptcha() {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        return Array.from({ length: 6 }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
    }

    const refreshCaptcha = () => {
        setCaptcha(generateCaptcha());
        setCaptchaInput('');
        setCaptchaError('');
    };

    useEffect(() => {
        if (resetFormotp.confirmPassword && resetFormotp.newPassword !== resetFormotp.confirmPassword) {
            setPasswordError('Passwords do not match');
        } else {
            setPasswordError('');
        }
    }, [resetFormotp.newPassword, resetFormotp.confirmPassword]);

    useEffect(() => {
        let timer;
        if (showResetPasswordModal) {
            setOtpTimer(120);
            setShowResendButton(false);

            timer = setInterval(() => {
                setOtpTimer(prev => {
                    if (prev <= 1) {
                        clearInterval(timer);
                        setShowResendButton(true);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        return () => clearInterval(timer);
    }, [otpTimerKey, showResetPasswordModal]);



    const formatTime = (seconds) => {
        const min = String(Math.floor(seconds / 60)).padStart(2, '0');
        const sec = String(seconds % 60).padStart(2, '0');
        return `${min}:${sec}`;
    };

    const initialFormState = {
        email: ""
    };

    const [formData, setFormData] = useState({
        email: ""
    });

    const passwordsMatch = formData.password === formData.password_confirmation;

    const resetForm = () => {
        setFormData({ email: '', password: '' });
    };

    // Close Modal
    const handleClose = () => {
        setShowModal(false);
        setShowAddForm(false);       // if you're conditionally rendering add form
        setFormData(initialFormState);
        setEmailSent(false);
    };

    const handleModalClose = () => {
        resetForm();
        onHide(); // call parent-provided function to close modal
    }

    // form change control
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        const buttonName = e.nativeEvent.submitter.name;
        if (form.checkValidity() === false) {
            e.stopPropagation();
            setValidated(true);
            return;
        }
        if (buttonName == "sendEmail") {
            const dat = { email: formData.email };
            const response = await emailVerify(dat);
            if (response.data.message === "OTP sent to your email.") {
                setEmailSent(true);
                Swal.fire({
                    title: "Success!",
                    text: response.data.message,
                    icon: "success",
                    confirmButtonText: "OK",
                });
            }
        } else if (buttonName == "otpverify") {
            const optData = {
                email: formData.email,
                otp: formData.otp
            }
            const response = await otpVerify(optData); // replace with your actual API call
            resetForm();
            if (response.data.message == 'OTP verified. You may now complete registration.') {
                setShowRegistrationModal(true); // Open registration modal
                // onClose();
            } else {
                // alert("Invalid OTP");
                Swal.fire({
                    title: "error",
                    text: response.data.message,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }
        }
        else if (buttonName == "register") {
            const optData = {
                email: formData.email,
                name: formData.name,
                organization: formData.organization,
                password: formData.password,
                password_confirmation: formData.password_confirmation,
                phone: formData.phone
            }
            const response = await userregistration(optData); // replace with your actual API call
            resetForm();
            if (response.data.message == 'User registered successfully.') {
                setShowRegistrationModal(true); // Open registration modal
                // onClose();
            } else {

            }
        }
        else if (buttonName == "login") {
            e.preventDefault();
            if (captchaInput !== captcha) {
                setCaptchaError('Captcha does not match');
                return;
            }
            setCaptchaError('');
            try {
                const optData = {
                    email: formData.email,
                    password: formData.password,
                }
                const response = await userlogin(optData); // replace with your actual API call
                const loggedInUser = {
                    ...(response.data.user || {}),
                    ...response.data,
                };
                localStorage.setItem('usercre', JSON.stringify(loggedInUser));
                // sessionStorage.setItem('adminToken', token);
                resetForm(); // Clear form after submission
                onHide()
                window.location.reload();
                if (response.status == 200) {
                    setShowLoginModal(false);
                    onHide()
                    Swal.fire({
                        title: "success",
                        text: response.data.message,
                        icon: "success",
                        confirmButtonText: "OK",
                    });
                } else {
                    Swal.fire({
                        title: "error",
                        text: response.data.message,
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                }
            } catch (err) {
                Swal.fire({
                    title: "Error!",
                    text: err?.response?.data?.message || err?.message,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }
        }
    };


    const handleVerifyEmailSubmit = async (e) => {
        e.preventDefault();
        try {
            let response;
            response = await userforgotpassword({ email: forgotEmail });
            if (response.status == 200) {
                Swal.fire({
                    title: "OTP sent on your registered email. Please check",
                    icon: "success",
                    showCancelButton: false,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Ok"
                })
                setShowVerifyEmailModal(false);
                setShowResetPasswordModal(true);

            } else {
                setError('Failed to send OTP. Try again.');
            }
        } catch (err) {
            Swal.fire({
                title: "Error",
                text: err?.response?.data?.message || err?.message,
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    };

    const handleResendOtp = async () => {
        try {
            const response = await userforgotpassword({ email: forgotEmail });
            if (response.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'OTP resent to your registered email',
                });

                // Reset timer by changing key
                setOtpTimerKey(prev => prev + 1);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Failed to resend OTP. Please try again.',
                });
            }
        } catch (error) {
            Swal.fire({
                title: "Error",
                text: error?.response?.data?.message || error?.message,
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    };



    const handleResetPasswordSubmit = async (e) => {
        e.preventDefault();
        if (resetFormotp.newPassword !== resetFormotp.confirmPassword) {
            Swal.fire({
                icon: 'error',
                title: 'Passwords do not match',
            });
            return;
        }
        try {
            const resetData = {
                email: forgotEmail, // Pass email from previous step
                token: resetFormotp.otp,
                password: resetFormotp.newPassword,
                password_confirmation: resetFormotp.newPassword,
            }
            const response = await userResetpassword(resetData);
            if (response.status === 200) {
                Swal.fire({
                    title: 'Password reset successful',
                    icon: 'success',
                    confirmButtonText: 'Login now'
                });
                setShowResetPasswordModal(false);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Reset failed',
                    text: response.data?.message || 'Try again later.'
                });
            }
        } catch (error) {
            Swal.fire({
                title: "Error",
                text: error?.response?.data?.message || error?.message,
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    };

    const isFormValid = () => {
        const { name, phone, email, organization, password, password_confirmation } = formData;
        return (
            email?.trim() !== '' &&
            password?.trim() !== ''
        );
    }
    return (
        <>
            <Modal show={show} onHide={handleModalClose} centered>
                <Modal.Header closeButton style={{ backgroundColor: "#FFA500" }}>
                    <Modal.Title> User Login</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{}}>
                    <Container>
                        <Form onSubmit={handleSubmit}>
                            <Row className="mb-3">
                                <Col md={12}>
                                    <Form.Group controlId="formEmail">
                                        <Form.Label style={{
                                            fontSize: 'medium',
                                            fontWeight: '600'
                                        }}>Email<span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="email"
                                            name="email"
                                            placeholder="Enter email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            style={{
                                                border: '1px solid #ed9003',
                                                color: '#000',
                                                padding: '5px',
                                                fontSize: 'smaller'
                                            }}
                                        // className="shadow-sm"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Group controlId="formPassword" style={{ position: 'relative' }}>
                                        <Form.Label style={{
                                            fontSize: 'medium',
                                            fontWeight: '600'
                                        }}>Password<span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type={showPassword ? 'text' : 'password'}
                                            name="password"
                                            placeholder="Enter password"
                                            value={formData.password}
                                            onChange={handleChange}
                                            style={{
                                                border: '1px solid #ed9003',
                                                color: '#000',
                                                padding: '5px',
                                                fontSize: 'smaller'
                                            }}
                                        // className="shadow-sm"
                                        />

                                        <i
                                            className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}
                                            onClick={() => setShowPassword(!showPassword)}
                                            style={{
                                                position: 'absolute',
                                                right: '10px',
                                                top: '38px',
                                                cursor: 'pointer',
                                                fontSize: '1rem',
                                                color: '#555'
                                            }}
                                        ></i>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col md={12}>
                                    <Form.Group controlId="formCaptcha">
                                        <Form.Label style={{ fontSize: 'medium', fontWeight: '600' }}>
                                            Captcha <span className="text-danger">*</span>
                                        </Form.Label>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter captcha"
                                                value={captchaInput}
                                                onChange={(e) => setCaptchaInput(e.target.value)}
                                                required
                                                style={{
                                                    border: '1px solid #ed9003',
                                                    color: '#000',
                                                    padding: '5px',
                                                    fontSize: 'smaller',
                                                    width: '150px'
                                                }}
                                            />
                                            <div
                                                style={{
                                                    backgroundColor: '#f0f0f0',
                                                    fontWeight: 'bold',
                                                    fontSize: '1.2rem',
                                                    padding: '6px 12px',
                                                    borderRadius: '4px',
                                                    userSelect: 'none',
                                                    letterSpacing: '2px'
                                                }}
                                            >
                                                {captcha}
                                            </div>
                                            <i
                                                className="bi bi-arrow-clockwise"
                                                onClick={refreshCaptcha}
                                                style={{ cursor: 'pointer', fontSize: '1.2rem' }}
                                                title="Refresh Captcha"
                                            ></i>
                                        </div>
                                        {captchaError && <div className="text-danger mt-1">{captchaError}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>

                            <div className="text-end mt-3">
                                <div className="mb-2 text-start">
                                    <span
                                        onClick={() => setShowVerifyEmailModal(true)}
                                        style={{
                                            color: 'blue',
                                            cursor: 'pointer',
                                            fontSize: 'small'
                                        }}
                                    >
                                        Forgot Password?
                                    </span>
                                </div>
                                <Button variant="primary" type="submit" name="login" disabled={!isFormValid()}>
                                    Login
                                </Button>{" "}
                                <div className="mt-3 text-center">
                                    <span style={{ fontSize: 'small' }}>
                                        Don’t have an account?{" "}
                                        <span onClick={onShowRegister} style={{
                                            color: 'blue',
                                            cursor: 'pointer'
                                        }}>Register here</span>
                                    </span>
                                </div>
                                <Registration
                                    show={showRegistrationModal}
                                    onHide={() => setShowRegistrationModal(false)}
                                />

                            </div>
                        </Form>
                    </Container>
                </Modal.Body>
            </Modal>
            <Modal show={showVerifyEmailModal} onHide={() => setShowVerifyEmailModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Verify Email</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleVerifyEmailSubmit}>
                        <Form.Group controlId="forgotEmail">
                            <Form.Label>Email<span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="Enter your email"
                                value={forgotEmail}
                                onChange={(e) => setForgotEmail(e.target.value)}
                                required
                            />
                        </Form.Group>
                        <div className="text-end mt-3">
                            <Button variant="primary" type="submit">
                                Send Reset Link
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
            <Modal show={showResetPasswordModal} onHide={() => setShowResetPasswordModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Reset Password</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleResetPasswordSubmit}>
                        <Form.Group className="mb-3" controlId="otp">
                            <Form.Label>
                                OTP <span className="text-danger">*</span>
                                {!showResendButton ? (
                                    <span style={{ marginLeft: '10px', fontSize: '0.85rem', color: '#28a745' }}>
                                        (OTP is valid for {formatTime(otpTimer)})
                                    </span>
                                ) : (
                                    <Button variant="link" onClick={handleResendOtp} style={{ marginLeft: '10px', padding: 0 }}>
                                        Resend OTP
                                    </Button>
                                )}
                            </Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter OTP"
                                value={resetFormotp.otp}
                                onChange={(e) => setResetForm({ ...resetFormotp, otp: e.target.value })}
                                required
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="newPassword">
                            <Form.Label>
                                New Password<span className="text-danger">*</span>
                            </Form.Label>
                            <div style={{ position: 'relative' }}>
                                <Form.Control
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder="Enter new password"
                                    value={resetFormotp.newPassword}
                                    onChange={(e) => setResetForm({ ...resetFormotp, newPassword: e.target.value })}
                                    required
                                />
                                <i
                                    className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}
                                    onClick={() => setShowPassword(!showPassword)}
                                    style={{
                                        position: 'absolute',
                                        right: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        cursor: 'pointer',
                                        fontSize: '1rem',
                                        color: '#555'
                                    }}
                                ></i>
                            </div>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="confirmPassword">
                            <Form.Label>
                                Confirm Password<span className="text-danger">*</span>
                            </Form.Label>
                            <div style={{ position: 'relative' }}>
                                <Form.Control
                                    type={showConfirmPassword ? 'text' : 'password'}
                                    placeholder="Confirm password"
                                    value={resetFormotp.confirmPassword}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setResetForm({ ...resetFormotp, confirmPassword: value });
                                        setPasswordMatchError(resetFormotp.newPassword !== value);
                                    }}
                                    isInvalid={passwordMatchError}
                                    required
                                />
                                <i
                                    className={`bi ${passwordMatchError ? 'bi-invalid' : ''} ${showConfirmPassword ? 'bi-eye-slash' : 'bi-eye'}`}
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    style={{
                                        position: 'absolute',
                                        right: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        cursor: 'pointer',
                                        fontSize: '1rem',
                                        color: '#555'
                                    }}
                                ></i>
                                <Form.Control.Feedback type="invalid">
                                    Passwords do not match.
                                </Form.Control.Feedback>
                            </div>
                        </Form.Group>
                        <div className="text-end">
                            <Button variant="primary" type="submit" disabled={otpTimer === 0}>
                                Reset Password
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>


        </>
    );


}

export default UserLogin;